/*
Controller: Login

Operations:
  login
  logout
*/
var Api = require('../config')
var LoginDef = require('../definitions/Login')

var Login = (function () {
  /*
  Operation: login
  Login to the platform
  Parameters:
    bodyRequest: Login object
  Responses:
    HTTP 200: Valid response
    HTTP 401: Login invalid
    HTTP 429: Too many requests
    HTTP 504: The request could not be fulfilled because a required service wasn&#39;t available
  */
  function loginLogin (bodyRequest) {
    return new Promise(function (resolve, reject) {
      try {
        LoginDef.validate(bodyRequest)
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var parameters = {}
      parameters = bodyRequest
      var path = '/login'
      Api
        .request({
          url: path,
          method: 'post',
          headers: {
            'content-type': 'application/json'
          },
          data: parameters
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  /*
  Operation: logout
  Logout from platform
  Parameters:
  Responses:
    HTTP 200: Valid response
  */
  function logoutLogin () {
    return new Promise(function (resolve, reject) {
      try {
      } catch (error) {
        var err = new Error()
        err.message = error.message || 'Unknown Validation Error'
        err.name = 'Validation Error'
        reject(err)
        return
      }
      var path = '/logout'
      Api
        .request({
          url: path,
          method: 'post'
        })
        .then(function (response) {
          resolve(response)
        })
        .catch(function (error) {
          var err = new Error()
          err.message = error.message || 'Unknown XHR Error'
          err.name = 'XHR Error'
          err.response = error.response
          reject(err)
        })
        .catch(err => {
          
        })
    })
  }
  var ret = {}
  ret['login'] = loginLogin
  ret['logout'] = logoutLogin
  return ret
})()

module.exports = Login
